import { Component, OnInit, Input } from '@angular/core';
import { AppState } from '../../../../store/app.state';
import { Store } from '@ngrx/store';
import { OpenAddAddressPopup } from '../../../../store/menu/menu.action';
import { Address } from '../../../../shared/model/authentication/account.model';
import { ModelStore } from 'src/app/shared/model.store';
import { DispCoordinates } from 'src/app/shared/model/dispensary/dispensary-dsp.model';

@Component({
  selector: 'app-address-table',
  templateUrl: './address-table.component.html',
  styleUrls: ['./address-table.component.scss']
})

export class AddressTableComponent implements OnInit {

  @Input() private userId: number;
  @Input() private defaultCoordinates: DispCoordinates;
  private addresses: Address[];

  constructor(
    private store: Store<AppState>,
    private modelStore: ModelStore) { }

  ngOnInit() {
    this.modelStore.addressesObservable.subscribe(addresses => {
      this.addresses = addresses
    });
    this.modelStore.getAddresses(this.userId, (errorMessage) => {
      console.log(errorMessage);
    });
  }

  deleteAddress(addressId: number){
    this.modelStore.deleteAddress(addressId, (errorMessage) => {
      console.log(errorMessage);
    });
  }

  setAddressAsDefault(addressId: number){
    this.modelStore.setAddressAsDefault(addressId, (errorMessage) => {
      console.log(errorMessage);
    });
  }

  showFormattedAddress(address: Address) {
    let streetNoComma = address.street.replace(/,\s*$/, '');
    let street = address.line2 && address.line2 !== '' ? streetNoComma + ' ' + address.line2 + ', ' : streetNoComma + ', ';
    return street + address.address;
  }

  addAddress() {
    this.store.dispatch(new OpenAddAddressPopup( { defaultCoordinates: this.defaultCoordinates } ));
  }
}
